module.exports = __webpack_public_path__ + "static/media/ninja.7f239506.mp3";